import Action from "../actions";
import AppSession from "../../services/session";

export function setAuthenticationAction(authData) {
    let data = {
        locale: authData.locale,
        userData: authData,
        token: authData.access_token,
        isAuthorized: authData.is_authenticated
    };
    AppSession.setAuth(data);
    localStorage.setItem('auth', JSON.stringify(data));
    return {
        type: Action.AUTHENTICATION,
        authData: data
    }
}
export function setLogoutAction(authData) {
    let data = {
        locale: 'vn',
        userData: {},
        token:{},
        isAuthorized: false
    };
    AppSession.setAuth(data);
    localStorage.setItem('auth', JSON.stringify(data));
    return {
        type: Action.AUTHENTICATION,
        authData: data
    }
}
export function handleUnauthorizedAction(unauthorizedData) {
    if (unauthorizedData.response && unauthorizedData.response.status === 401) {
    }
    let data = {
        locale: 'vn',
        userData: {},
        token: '',
        isAuthorized: false
    };
    localStorage.setItem('auth', JSON.stringify(data));
    return {
        type: unauthorizedData.response && unauthorizedData.response.status === 401 ? Action.UNAUTHORIZED : Action.UNKNOWN,
        authData: unauthorizedData.response && unauthorizedData.response.status === 401 ? data : ''
    }
}
